import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.regexp.split.js";
import Vue from 'vue';
import { onSSR } from "../../plugins/Platform.js";
import QScrollObserver from "../scroll-observer/QScrollObserver.js";
import QResizeObserver from "../resize-observer/QResizeObserver.js";
import ListenersMixin from "../../mixins/listeners.js";
import { getScrollbarWidth } from "../../utils/scroll.js";
import { mergeSlot } from "../../utils/slot.js";
import cache from "../../utils/cache.js";
export default Vue.extend({
  name: 'QLayout',
  mixins: [ListenersMixin],
  provide: function provide() {
    return {
      layout: this
    };
  },
  props: {
    container: Boolean,
    view: {
      type: String,
      default: 'hhh lpr fff',
      validator: function validator(v) {
        return /^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(v.toLowerCase());
      }
    }
  },
  data: function data() {
    return {
      // page related
      height: this.$q.screen.height,
      width: this.container === true ? 0 : this.$q.screen.width,
      // container only prop
      containerHeight: 0,
      scrollbarWidth: onSSR === true ? 0 : getScrollbarWidth(),
      header: {
        size: 0,
        offset: 0,
        space: false
      },
      right: {
        size: 300,
        offset: 0,
        space: false
      },
      footer: {
        size: 0,
        offset: 0,
        space: false
      },
      left: {
        size: 300,
        offset: 0,
        space: false
      },
      scroll: {
        position: 0,
        direction: 'down'
      }
    };
  },
  computed: {
    rows: function rows() {
      var rows = this.view.toLowerCase().split(' ');
      return {
        top: rows[0].split(''),
        middle: rows[1].split(''),
        bottom: rows[2].split('')
      };
    },
    style: function style() {
      return this.container === true ? null : {
        minHeight: this.$q.screen.height + 'px'
      };
    },
    // used by container only
    targetStyle: function targetStyle() {
      if (this.scrollbarWidth !== 0) {
        return _defineProperty({}, this.$q.lang.rtl === true ? 'left' : 'right', "".concat(this.scrollbarWidth, "px"));
      }
    },
    targetChildStyle: function targetChildStyle() {
      if (this.scrollbarWidth !== 0) {
        var _ref2;

        return _ref2 = {}, _defineProperty(_ref2, this.$q.lang.rtl === true ? 'right' : 'left', 0), _defineProperty(_ref2, this.$q.lang.rtl === true ? 'left' : 'right', "-".concat(this.scrollbarWidth, "px")), _defineProperty(_ref2, "width", "calc(100% + ".concat(this.scrollbarWidth, "px)")), _ref2;
      }
    },
    totalWidth: function totalWidth() {
      return this.width + this.scrollbarWidth;
    },
    classes: function classes() {
      return 'q-layout q-layout--' + (this.container === true ? 'containerized' : 'standard');
    }
  },
  created: function created() {
    this.instances = {};
  },
  render: function render(h) {
    var layout = h('div', {
      class: this.classes,
      style: this.style,
      on: _objectSpread({}, this.qListeners)
    }, mergeSlot([h(QScrollObserver, {
      on: cache(this, 'scroll', {
        scroll: this.__onPageScroll
      })
    }), h(QResizeObserver, {
      on: cache(this, 'resizeOut', {
        resize: this.__onPageResize
      })
    })], this, 'default'));
    return this.container === true ? h('div', {
      staticClass: 'q-layout-container overflow-hidden'
    }, [h(QResizeObserver, {
      on: cache(this, 'resizeIn', {
        resize: this.__onContainerResize
      })
    }), h('div', {
      staticClass: 'absolute-full',
      style: this.targetStyle
    }, [h('div', {
      staticClass: 'scroll',
      style: this.targetChildStyle
    }, [layout])])]) : layout;
  },
  methods: {
    __animate: function __animate() {
      var _this = this;

      if (this.timer !== void 0) {
        clearTimeout(this.timer);
      } else {
        document.body.classList.add('q-body--layout-animate');
      }

      this.timer = setTimeout(function () {
        document.body.classList.remove('q-body--layout-animate');
        _this.timer = void 0;
      }, 150);
    },
    __onPageScroll: function __onPageScroll(data) {
      if (this.container === true || document.qScrollPrevented !== true) {
        this.scroll = data;
      }

      this.qListeners.scroll !== void 0 && this.$emit('scroll', data);
    },
    __onPageResize: function __onPageResize(_ref3) {
      var height = _ref3.height,
          width = _ref3.width;
      var resized = false;

      if (this.height !== height) {
        resized = true;
        this.height = height;

        if (this.qListeners['scroll-height'] !== void 0) {
          this.$emit('scroll-height', height);
        }

        this.__updateScrollbarWidth();
      }

      if (this.width !== width) {
        resized = true;
        this.width = width;
      }

      if (resized === true && this.qListeners.resize !== void 0) {
        this.$emit('resize', {
          height: height,
          width: width
        });
      }
    },
    __onContainerResize: function __onContainerResize(_ref4) {
      var height = _ref4.height;

      if (this.containerHeight !== height) {
        this.containerHeight = height;

        this.__updateScrollbarWidth();
      }
    },
    __updateScrollbarWidth: function __updateScrollbarWidth() {
      if (this.container === true) {
        var width = this.height > this.containerHeight ? getScrollbarWidth() : 0;

        if (this.scrollbarWidth !== width) {
          this.scrollbarWidth = width;
        }
      }
    }
  }
});